module.exports = __webpack_public_path__ + "static/media/Dribbble-colored.6ea5a73f.svg";